import ManageMakeTable from './manageMakeTable'

export default ManageMakeTable
